import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';
import PricingPersonaHero from './PricingPersonaHero';
import PricingJourneySection from './PricingJourneySection';

const CARDS = [
    { label: 'Free', amount: '£0', sub: 'free forever', text: 'Get oriented and see what investor-ready looks like.', cta: { text: 'Get started free', href: ROUTES.REGISTER }, variant: '' },
    { label: 'Lite', amount: '£8.25', sub: '/ mo · £99/yr', text: 'Build your data foundation and start your pre-seed raise.', cta: { text: 'Get started', href: ROUTES.REGISTER }, variant: 'lp-price--lite' },
    { label: 'Pro', amount: '£83.25', sub: '/ mo · £999/yr', text: 'Everything you need to pass Pre-Seed / Seed / Series A due diligence.', cta: { text: 'Get Pro', href: ROUTES.REGISTER }, variant: 'lp-price--pro', badge: 'Most Popular' },
    { label: 'Portfolio Pro', amount: '£66.67', sub: '/ mo · £800/yr via advisor', text: 'All Pro features at a 20% discount, introduced by your advisor.', cta: { text: 'Learn more', href: '#whats-included' }, variant: 'lp-price--dark', badge: '20% off Pro', badgeColor: '#1F8A5B' },
];

const PricingCompaniesPanel = () => (
    <div role="tabpanel">
        <PricingPersonaHero
            eyebrow="Pricing"
            dotColor="#FC7785"
            title="Simple plans. Built for every stage."
            subtitle="Start free. Upgrade when you're ready to grow, raise or exit."
            primaryCta={{ text: 'Try for free', href: ROUTES.REGISTER }}
            secondaryCta={{ text: 'See what you get ↓', href: '#whats-included' }}
        />

        <section className="lp-pricing-sec" style={{ paddingTop: 0, background: 'transparent' }}>
            <div className="lp-pricing-grid lp-pricing-grid--4">
                {CARDS.map((c, i) => (
                    <div className={`lp-price ${c.variant}`} key={i} data-lp-reveal data-lp-delay={i * 70}>
                        {c.badge && (c.label === 'Pro'
                            ? <div className="lp-price-badge lp-price-badge--center">{c.badge}</div>
                            : <div className="lp-price-badge-inline" style={{ background: c.badgeColor }}>{c.badge}</div>)}
                        <div className="lbl" style={{ color: (c.label == 'Pro' || c.label == 'Portfolio Pro') ? '#fff' : '#5b6472' }}>{c.label}</div>
                        <div className={`amt ${c.variant === 'lp-price--lite' ? 'blue' : c.variant === 'lp-price--dark' || c.variant === 'lp-price--pro' ? 'white' : ''}`}>{c.amount}</div>
                        <div className="sub">{c.sub}</div>
                        <p style={{ flex: 1 }}>{c.text}</p>
                        <a className={`lp-price-btn ${c.variant === 'lp-price--pro' ? 'lp-price-btn--white' : c.variant === 'lp-price--dark' ? 'lp-price-btn--outline' : 'lp-price-btn--dark'}`} href={c.cta.href}>{c.cta.text}</a>
                    </div>
                ))}
            </div>

            <div className="lp-pricing-nudge" data-lp-reveal data-lp-delay="80">
                <span className="emoji">🧭</span>
                <div>
                    <span className="ttl">Need expert guidance?</span>
                    <span className="txt"> We'll match you with an advisor who specialises in your sector — and they'll unlock Portfolio Pro for you too. </span>
                    <a href="#whats-included">Find my advisor →</a>
                </div>
            </div>
        </section>

        <PricingJourneySection />

        <section className="lp-cta">
            <div className="lp-cta-card lp-cta-card--emoji" data-lp-reveal>
                <div className="emoji">🤝</div>
                <div className="lp-cta-inner">
                    <h2 style={{ fontSize: 'clamp(20px,2.8vw,28px)' }}><strong>You pitch for Investment</strong> — qualified, diligence-backed, more attractive to every investor.</h2>
                    <Link className="lp-cta-btn" to={ROUTES.REGISTER}>
                        <span>Try for FREE</span>
                        <span className="note">no credit card required</span>
                    </Link>
                    <p className="fine">* Portfolio Pro (£800/yr) available only when introduced by a participating advisor or investor.</p>
                </div>
            </div>
        </section>
    </div>
);

export default PricingCompaniesPanel;
